import skeletonStyles from "./SkeletonStyles.module.css";

const Skeleton = () => {
  return (
    <div className={skeletonStyles["skeleton-container"]}>
      <div className={skeletonStyles["skeleton-box2"]} />
    </div>
  );
};

export default Skeleton;